import { useCallback } from 'react';
import type {
	ChildResult,
	CommandSections,
} from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { QUICK_SEARCH_PRIORITY } from '../../../../../common/ui/constants.tsx';
import { useGetQuickSearchPlanCommands } from '../../../../../common/ui/plan/index.tsx';
import type {
	GetQuickSearchChildResultProps,
	UseGetChildResult,
} from '../../../../../common/ui/types.tsx';
import { SECTION_ID } from './constants.tsx';
import { messages } from './messages.tsx';

export const useGetRecentPlansChildResult: UseGetChildResult = () => {
	const { formatMessage } = useIntl();
	const { getQuickSearchPlanCommands } = useGetQuickSearchPlanCommands({
		section: SECTION_ID,
		showViewAll: false,
	});

	const getChildResult = useCallback(
		(props: GetQuickSearchChildResultProps): ChildResult => {
			const sections: CommandSections = {
				[SECTION_ID]: {
					id: SECTION_ID,
					name: formatMessage(messages.recentlyViewedPlans),
					priority: QUICK_SEARCH_PRIORITY.PLANS,
				},
			};
			const commands = getQuickSearchPlanCommands(props);

			return {
				sections,
				commands,
			};
		},
		[formatMessage, getQuickSearchPlanCommands],
	);

	return { getChildResult };
};
